import React from 'react';
import { MathJax, MathJaxContext } from 'better-react-mathjax';

const config = {
    loader: { load: ['[tex]/ams'] },
    tex: {
        inlineMath: [['$', '$'], ['\\(', '\\)']],
        displayMath: [['$$', '$$'], ['\\[', '\\]']],
        packages: { '[+]': ['ams'] },
    },
};

function MathRenderer({ formula }) {
    return (
        <MathJaxContext config={config}>
            <MathJax>
                {formula}
            </MathJax>
        </MathJaxContext>
    );
}

export default MathRenderer;